import React from 'react';

import CustomTable from '../../../../common/custom/CustomTable/custom-table.component';
import ViewAttachmentsModal from '../../../../common/custom/Modals/ViewAttachmentsModal/modal';
import { SHIPMENTS } from '../../../../constants/columns';
import DeleteModal from '../../../modals/delete-modal';
import ShipmentsActionMenu from '../shipmentsActionMenu';
import { useAllShipmentsList } from './useAllShimentsList';
import { TOAST_TIME } from "../../../../constants/toastNotifications";
import useApi from '../../../../hook/useApi';
import toast from "react-hot-toast";
import {generateShipmentPdfQuery} from '../../../../api/services/shipments.service'
const AllShipmentsList = ({ allShipmentsData, columns = SHIPMENTS }) => {
  const {
    open,
    handleClose,
    attachments,
    showDeleteModal,
    cancelShipmentHandler,
    closeDeleteModal,
    shipmentActionClickedId,
    toggleActionMenu,
    shipmentActionClickedData,
    openDeleteModal,
    handleActionClick,
    actionMenuRef,
    handleViewAttachments,
    cancelShipmentLoading,
  } = useAllShipmentsList(allShipmentsData);

  const [generateShipmentPdfCall, pdfLoading] = useApi(generateShipmentPdfQuery);

  const handleDownload = async (id) => {
    const { data, error } = await generateShipmentPdfCall(parseInt(id));
    if (data?.ShipmentInvoice?.url && data?.ShipmentInvoice?.url !== undefined && data?.ShipmentInvoice?.url !== '' && data?.ShipmentInvoice?.url !== null) {
      const pdfUrl = data?.ShipmentInvoice.url;
      toast.loading('Shipment Certificate downloading...', { duration: TOAST_TIME });
      // Open the PDF in a new tab
      window.open(pdfUrl, '_blank');
      console.log('PDF opened in a new tab:', pdfUrl);
    } else {
      toast.dismiss();
      toast.error('Failed to download Shipment certificate.', { duration: TOAST_TIME });
    }
  }
  
  return (
    <>
      {showDeleteModal ? (
        <DeleteModal
          modalHeading='Delete Shipment?'
          modalPara='Are you sure you want to delete this Shipment? This action cannot be undone.'
          deleteHandler={() => cancelShipmentHandler(shipmentActionClickedId)}
          closeDeleteModal={closeDeleteModal}
          deleteLoading={cancelShipmentLoading}
        />
      ) : null}

      {open && (
        <ViewAttachmentsModal
          onClose={handleClose}
          title='View Attachments'
          files={attachments}
        />
      )}

      <CustomTable
        header={columns}
        rows={allShipmentsData}
        {...{ handleActionClick, toggleActionMenu }}
        actionMenuRef={actionMenuRef}
        menu={
          <ShipmentsActionMenu
            data={shipmentActionClickedData}
            handleDownload={handleDownload}
            openDeleteModal={openDeleteModal}
            handleViewAttachments={handleViewAttachments}
          // openViewClaimModal={openViewClaimModal}
          />
        }
      />
    </>
  );
};

export default AllShipmentsList;
